import React, { useRef, useEffect, useState } from 'react';
import FinFriendVideo from '../assets/FinFriend.mp4';
import NTImage from '../assets/NT.png';
import MyfyeMockup from '../assets/MyfyeMockup.png';
import BatUCIMockup from '../assets/BatUCIMockup.png';

export default function ExperienceSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const isSmallScreen = window.innerWidth <= 750;
  const [hoveredNT, setHoveredNT] = useState(false);
  const [hoveredFinFriend, setHoveredFinFriend] = useState(false);
  const [hoveredMyfye, setHoveredMyfye] = useState(false);
  const [hoveredBatUCI, setHoveredBatUCI] = useState(false);
  const [hoveredNTLink, setHoveredNTLink] = useState(false);
  const [hoveredFinFriendLink, setHoveredFinFriendLink] = useState(false);
  const [hoveredMyfyeLink, setHoveredMyfyeLink] = useState(false);
  const [hoveredBatUCILink, setHoveredBatUCILink] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      // Ensure video is muted for autoplay
      video.muted = true;
      video.setAttribute('muted', '');
      
      // Try to play immediately
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          // Autoplay was prevented - try again when user interacts
          const tryPlay = () => {
            video.play().catch(() => {
              // Silently fail - autoplay not supported
            });
            // Remove listeners after first interaction
            document.removeEventListener('touchstart', tryPlay);
            document.removeEventListener('scroll', tryPlay);
          };
          document.addEventListener('touchstart', tryPlay, { once: true });
          document.addEventListener('scroll', tryPlay, { once: true });
        });
      }
    }
  }, []);

  return (
    <div>
        <div style={{marginTop: isSmallScreen ? '50px' : '-80px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '40px', zIndex: 10, position: 'relative'}}>
            <div style={{
                width: isSmallScreen ? '40px' : 'clamp(80px, 25vw, 600px)',
                height: '3px',
                backgroundColor: '#333333',
            }}></div>
            <div style={{fontSize: isSmallScreen ? '35px' : '55px', color: '#333333', 
                textAlign: 'center'}}>
                Experience
            </div>
            <div style={{
                width: isSmallScreen ? '40px' : 'clamp(80px, 25vw, 600px)',
                height: '3px',
                backgroundColor: '#333333',
            }}></div>
        </div>

        {/* Grid container for larger screens, stacked for mobile */}
        <div style={{
            display: isSmallScreen ? 'flex' : 'grid',
            flexDirection: isSmallScreen ? 'column' : undefined,
            gridTemplateColumns: isSmallScreen ? 'none' : 'repeat(2, 1fr)',
            gap: isSmallScreen ? '0' : '30px',
            justifyContent: 'center',
            alignItems: 'center',
            padding: isSmallScreen ? '0' : '20px 40px',
            zIndex: 10,
            position: 'relative',
            width: '100%',
            maxWidth: isSmallScreen ? '100%' : '90vw',
            margin: isSmallScreen ? '40px 0 0 0' : '40px auto 0 auto'
        }}>
            {/* NT Image */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: isSmallScreen ? '40px' : '0',
                padding: isSmallScreen ? '20px' : '0',
                width: '100%'
            }}>
                <div 
                    style={{
                        width: isSmallScreen ? '90vw' : '100%',
                        maxWidth: isSmallScreen ? '90vw' : '100%',
                        maxHeight: '70vh',
                        backgroundColor: hoveredNT ? 'white' : 'white',
                        borderRadius: '20px',
                        border: hoveredNT ? '3px solid #333333' : '3px solid transparent',
                        boxShadow: '0px 4px 6px rgba(0, 0.1, 0.1, 0.5)',
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative',
                        transition: 'background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out, border 0.3s ease-in-out'
                    }}
                    onMouseEnter={() => setHoveredNT(true)}
                    onMouseLeave={() => setHoveredNT(false)}
                >
                    <img
                        src={NTImage}
                        alt="NT"
                        onContextMenu={(e) => e.preventDefault()}
                        onDragStart={(e) => e.preventDefault()}
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '70vh',
                            objectFit: 'contain',
                            display: 'block',
                            pointerEvents: 'none',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none',
                            outline: 'none',
                            opacity: hoveredNT ? 0.1 : 1,
                            transition: 'opacity 0.3s ease-in-out'
                        }}
                    />
                    {hoveredNT && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            padding: '20px',
                            borderRadius: '20px'
                        }}>
                            <p style={{
                                color: '#333333',
                                fontSize: isSmallScreen ? '3.4vw' : '1.8vw',
                                lineHeight: '1.3',
                                margin: 0
                            }}>
                                As a Software Engineer In Test Intern at NinjaTrader, I worked on the QA team. I was focused on testing and workflow automation. 
                                I helped get new code out faster by saving the team over <span style={{ fontWeight: 'bold' }}>1 hour</span> of manual testing time per week. I also developed general purpose
                                 API endpoints as internal tools for use on future projects. <a href="https://ninjatrader.com/" target="_blank" onMouseEnter={() => setHoveredNTLink(true)} onMouseLeave={() => setHoveredNTLink(false)} style={{ color: hoveredNTLink ? '#004499' : '#0066CC', textDecoration: 'underline', cursor: 'pointer', transition: 'color 0.2s ease' }}>ninjatrader.com</a>
                            </p>
                        </div>
                    )}
                </div>
            </div>
            
            {/* FinFriend Video */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: isSmallScreen ? '40px' : '0',
                padding: isSmallScreen ? '20px' : '0',
                width: '100%'
            }}>
                <div 
                    style={{
                        width: isSmallScreen ? '90vw' : '100%',
                        maxWidth: isSmallScreen ? '90vw' : '100%',
                        maxHeight: '70vh',
                        backgroundColor: hoveredFinFriend ? 'white' : 'white',
                        borderRadius: '20px',
                        border: hoveredFinFriend ? '3px solid #333333' : '3px solid transparent',
                        boxShadow: '0px 4px 6px rgba(0, 0.1, 0.1, 0.5)',
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative',
                        transition: 'background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out, border 0.3s ease-in-out'
                    }}
                    onMouseEnter={() => setHoveredFinFriend(true)}
                    onMouseLeave={() => setHoveredFinFriend(false)}
                >
                    <video
                        ref={videoRef}
                        src={FinFriendVideo}
                        autoPlay
                        loop
                        muted
                        playsInline
                        preload="auto"
                        disablePictureInPicture
                        disableRemotePlayback
                        controlsList="nodownload nofullscreen noremoteplayback"
                        onContextMenu={(e) => e.preventDefault()}
                        onDragStart={(e) => e.preventDefault()}
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '70vh',
                            objectFit: 'contain',
                            display: 'block',
                            pointerEvents: 'none',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none',
                            outline: 'none',
                            opacity: hoveredFinFriend ? 0.1 : 1,
                            transition: 'opacity 0.3s ease-in-out'
                        }}
                    >
                        Your browser does not support the video tag.
                    </video>
                    {hoveredFinFriend && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            padding: '20px',
                            borderRadius: '20px'
                        }}>
                            <p style={{
                                color: '#333333',
                                fontSize: isSmallScreen ? '3.4vw' : '1.8vw',
                                lineHeight: '1.3',
                                margin: 0
                            }}>
                                FinFriend is the "friend" that helps you "finance": a create-your-own-currency platform. A passion project that I built over the course of 2 years, it generated over <span style={{ fontWeight: 'bold' }}>$1k</span> in sales.
                                Available now on iOS and the web, it implements an 
                                asynchronous, event-driven exchange engine. <a href="https://www.finfriend.com/" target="_blank" onMouseEnter={() => setHoveredFinFriendLink(true)} onMouseLeave={() => setHoveredFinFriendLink(false)} style={{ color: hoveredFinFriendLink ? '#004499' : '#0066CC', textDecoration: 'underline', cursor: 'pointer', transition: 'color 0.2s ease' }}>finfriend.com</a>
                            </p>
                        </div>
                    )}
                </div>
            </div>

            {/* Myfye Mockup */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: isSmallScreen ? '40px' : '0',
                padding: isSmallScreen ? '20px' : '0',
                width: '100%'
            }}>
                <div 
                    style={{
                        width: isSmallScreen ? '90vw' : '100%',
                        maxWidth: isSmallScreen ? '90vw' : '100%',
                        maxHeight: '70vh',
                        backgroundColor: hoveredMyfye ? 'white' : 'white',
                        borderRadius: '20px',
                        border: hoveredMyfye ? '3px solid #333333' : '3px solid transparent',
                        boxShadow: '0px 4px 6px rgba(0, 0.1, 0.1, 0.5)',
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative',
                        transition: 'background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out, border 0.3s ease-in-out'
                    }}
                    onMouseEnter={() => setHoveredMyfye(true)}
                    onMouseLeave={() => setHoveredMyfye(false)}
                >
                    <img
                        src={MyfyeMockup}
                        alt="MyFye Mockup"
                        onContextMenu={(e) => e.preventDefault()}
                        onDragStart={(e) => e.preventDefault()}
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '70vh',
                            objectFit: 'contain',
                            display: 'block',
                            pointerEvents: 'none',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none',
                            outline: 'none',
                            opacity: hoveredMyfye ? 0.1 : 1,
                            transition: 'opacity 0.3s ease-in-out'
                        }}
                    />
                    {hoveredMyfye && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            padding: '20px',
                            borderRadius: '20px'
                        }}>
                            <p style={{
                                color: '#333333',
                                fontSize: isSmallScreen ? '3.4vw' : '1.8vw',
                                lineHeight: '1.3',
                                margin: 0
                            }}>
                                Myfye started as a freelance engagement and evolved into the founding engineer role. Winning <span style={{ fontWeight: 'bold' }}>$10k</span> at the Solana Hackathon, it uses embedded wallets 
                                and tokenized treasuries to enable real world assets to be held non-custodially. What does that mean? It means you can 
                                hold Apple or Google stock right on your phone! <a href="https://myfye.com/" target="_blank" onMouseEnter={() => setHoveredMyfyeLink(true)} onMouseLeave={() => setHoveredMyfyeLink(false)} style={{ color: hoveredMyfyeLink ? '#004499' : '#0066CC', textDecoration: 'underline', cursor: 'pointer', transition: 'color 0.2s ease' }}>myfye.com</a>
                            </p>
                        </div>
                    )}
                </div>
            </div>

            {/* Blockchain at UCI Mockup */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: isSmallScreen ? '40px' : '0',
                padding: isSmallScreen ? '20px' : '0',
                width: '100%'
            }}>
                <div 
                    style={{
                        width: isSmallScreen ? '90vw' : '100%',
                        maxWidth: isSmallScreen ? '90vw' : '100%',
                        maxHeight: '70vh',
                        backgroundColor: hoveredBatUCI ? 'white' : 'white',
                        borderRadius: '20px',
                        border: hoveredBatUCI ? '3px solid #333333' : '3px solid transparent',
                        boxShadow: '0px 4px 6px rgba(0, 0.1, 0.1, 0.5)',
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative',
                        transition: 'background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out, border 0.3s ease-in-out'
                    }}
                    onMouseEnter={() => setHoveredBatUCI(true)}
                    onMouseLeave={() => setHoveredBatUCI(false)}
                >
                    <img
                        src={BatUCIMockup}
                        alt="Blockchain at UCI Mockup"
                        onContextMenu={(e) => e.preventDefault()}
                        onDragStart={(e) => e.preventDefault()}
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '70vh',
                            objectFit: 'contain',
                            display: 'block',
                            pointerEvents: 'none',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none',
                            outline: 'none',
                            opacity: hoveredBatUCI ? 0.1 : 1,
                            transition: 'opacity 0.3s ease-in-out'
                        }}
                    />
                    {hoveredBatUCI && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            padding: '20px',
                            borderRadius: '20px'
                        }}>
                            <p style={{
                                color: '#333333',
                                fontSize: isSmallScreen ? '3.4vw' : '1.8vw',
                                lineHeight: '1.3',
                                margin: 0
                            }}>
                                Blockchain at UCI is a student-run organization where I served as the technical lead. I led a team of <span style={{ fontWeight: 'bold' }}>10+ STEM students </span> 
                                in building a blockchain-based rental marketplace which won the Eigen Games Eth Denver Hackathon. <a href="https://www.blockchainuci.org/" target="_blank" onMouseEnter={() => setHoveredBatUCILink(true)} onMouseLeave={() => setHoveredBatUCILink(false)} style={{ color: hoveredBatUCILink ? '#004499' : '#0066CC', textDecoration: 'underline', cursor: 'pointer', transition: 'color 0.2s ease' }}>blockchainatuci.com</a>
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>

    </div>
  );
}

